import api from './api';

const authService = {
  // Login user
  async login(email, password) {
    try {
      // In a real application, this would be an actual API endpoint
      const response = await api.post('/members/login', { email, password });

      // Save token and user details
      if (response.data.token) {
        localStorage.setItem('token', response.data.token);
      }

      return response.data;
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  },

  // Logout user
  async logout() {
    try {
      const response = await api.post('/members/logout');
      return response.data;
    } catch (error) {
      console.error('Logout error:', error);
      throw error;
    } finally {
      localStorage.removeItem('token');
    }
  },

  // Get current user data
  async getMe() {
    try {
      const response = await api.get('/members/me');
      return response.data.member;
    } catch (error) {
      console.error('Get current user error:', error);
      throw error;
    }
  },

  // Register new user
  async register(userData) {
    try {
      const response = await api.post('/members/register', userData);
      return response.data;
    } catch (error) {
      console.error('Register error:', error);
      throw error;
    }
  },

  // Send email verification code
  async sendVerificationEmail() {
    try {
      const response = await api.post('/members/send-verification-email');
      return response.data;
    } catch (error) {
      console.error('Send verification email error:', error);
      throw error;
    }
  },

  // Verify email with code
  async verifyEmail(code) {
    try {
      const response = await api.post('/members/verify-email', { code });
      return response.data;
    } catch (error) {
      console.error('Email verification error:', error);
      throw error;
    }
  },

  // Send phone verification code
  async sendVerificationSMS() {
    try {
      const response = await api.post('/members/send-verification-sms');
      return response.data;
    } catch (error) {
      console.error('Send verification SMS error:', error);
      throw error;
    }
  },

  // Verify phone with code
  async verifyPhone(code) {
    try {
      const response = await api.post('/members/verify-phone', { code });
      return response.data;
    } catch (error) {
      console.error('Phone verification error:', error);
      throw error;
    }
  },

  // Request password reset
  async requestPasswordReset(email) {
    try {
      const response = await api.post('/members/send-password-reset', { email });
      return response.data;
    } catch (error) {
      console.error('Password reset request error:', error);
      throw error;
    }
  },

  // Reset password with code
  async resetPassword(data) {
    try {
      const response = await api.post('/members/reset-password', data);
      return response.data;
    } catch (error) {
      console.error('Password reset error:', error);
      throw error;
    }
  },

  // Update user profile
  async updateProfile(data) {
    try {
      const response = await api.patch('/members/me', data);
      return response.data;
    } catch (error) {
      console.error('Password reset error:', error);
      throw error;
    }
  }
};

export default authService;